import { configureStore } from "@reduxjs/toolkit";
import audioTracks from "./slices/audioTracks";
import news from "./slices/news";
import artists from "./slices/artists";
import playlists from "./slices/playlists";
import main from "./slices/main";
import contests from "./slices/contests";
import staticPages from "./slices/staticPages";
import rizdvoniki from "./slices/rizdvoniki";

export const store = configureStore({
  reducer: {
    audioTracks,
    news,
    artists,
    playlists,
    main,
    contests,
    staticPages,
    rizdvoniki,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
